var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export var splitStringByLineLength = function (inputString, maxLineLength) {
  var e_1, _a;
  if (maxLineLength === void 0) {
    maxLineLength = 20;
  }
  // Split the input string into individual words
  var words = inputString.trim().split(/\s+/);
  // Array to hold the lines of words
  var lines = [];
  // Initialize variables for current line
  var currentLine = [];
  var currentLineLength = 0;
  try {
    // Process each word
    for (var words_1 = __values(words), words_1_1 = words_1.next(); !words_1_1.done; words_1_1 = words_1.next()) {
      var word = words_1_1.value;
      var wordLength = word.length;
      // If adding this word exceeds the maxLineLength, start a new line
      if (currentLineLength + currentLine.length + wordLength > maxLineLength) {
        lines.push(currentLine.join(' '));
        currentLine = [];
        currentLineLength = 0;
      }
      // Add the word to the current line
      currentLine.push(word);
      currentLineLength += wordLength;
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (words_1_1 && !words_1_1.done && (_a = words_1.return)) _a.call(words_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  // Add the last line to the lines array
  if (currentLine.length > 0) {
    lines.push(currentLine.join(' '));
  }
  return lines;
};